import apiHandler from "../core/apiHandler";

const settlementsApi = apiHandler('settlements');
export default settlementsApi;
